var map = {
	"./image-carousel.de-CH.json": 1432,
	"./image-carousel.de-DE.json": 1433,
	"./image-carousel.en-CA.json": 1434,
	"./image-carousel.en-GB.json": 1435,
	"./image-carousel.en-IN.json": 1436,
	"./image-carousel.en-ME.json": 1437,
	"./image-carousel.en-US.json": 1438,
	"./image-carousel.es-EM.json": 1439,
	"./image-carousel.es-ES.json": 1440,
	"./image-carousel.fr-BE.json": 1441,
	"./image-carousel.fr-CA.json": 1442,
	"./image-carousel.fr-CH.json": 1443,
	"./image-carousel.nl-BE.json": 1444,
	"./image-carousel.nl-NL.json": 1445,
	"./image-carousel.pl-PL.json": 1446,
	"./image-carousel.pt-BR.json": 1447
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1431;